import React, { FC } from 'react'

import { AccountScoped } from 'shared/react-admin'
import { BreadcrumbType } from './'
import { TeamPanel } from 'dash/shared/molecules/TeamPanel'
import { Typography } from 'antd'
import AppState from 'shared/app_state'

const Breadcrumb: FC<{ breadcrumb: BreadcrumbType }> = ({ breadcrumb }) => {
  return (
    breadcrumb && (
      <div
        style={{
          display: 'flex',
          flexFlow: 'column nowrap',
          marginTop: 3,
        }}
      >
        <Typography.Text
          type="secondary"
          strong
          style={{ textTransform: 'uppercase', margin: 0, fontSize: '14px', lineHeight: '24px' }}
        >
          {breadcrumb.path.join(' / ')}
        </Typography.Text>
        <Typography.Title
          level={1}
          style={{
            margin: 0,
            fontSize: '28px',
          }}
        >
          {breadcrumb.label}
        </Typography.Title>
      </div>
    )
  )
}

export const CustomLayoutHeader: FC<{ breadcrumb: BreadcrumbType }> = ({ breadcrumb }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginTop: 10,
      }}
    >
      <Breadcrumb breadcrumb={breadcrumb} />
      {AppState.getIsAccountView() && (
        <AccountScoped view="Team Panel">{(accountId: string) => <TeamPanel accountId={accountId} />}</AccountScoped>
      )}
    </div>
  )
}
